import { getPackTabProducts } from '~/lib/handle-api'

export async function fetchAndSerializeTabProducts(
  tabIds,
  fetchedProducts,
  locale,
) {
  // Get the ids of the products that aren't already serialized to lighten our call
  const idsToFetch = tabIds.filter((id) => {
    return (
      fetchedProducts.findIndex((product) => product.shopifyId === id) === -1
    )
  })

  const products =
    idsToFetch?.length > 0
      ? (
          await getPackTabProducts({
            payload: {
              locale,
              ids: idsToFetch,
            },
          })
        )?.products?.[0]
      : []

  // Assign serialized products from our call and the global data by shopifyId
  const allProducts = tabIds
    .map((id) =>
      []
        .concat(products)
        .concat(fetchedProducts)
        .find((product) => id === product.shopifyId),
    )
    .filter(Boolean)

  return allProducts
}
